<template>
    <div>
      <Header @changeActive="changeActive" ref="headRef"></Header>
        <v-container class="text-center tabHeader the-main-concept">
            <h1>{{$t('profile.add_need')}}</h1>
        </v-container>

      <v-container class="ex-add-product">
        <v-form ref="form" v-model="valid" lazy-validation class="ex-add-product-page">
          <v-layout row wrap>
            <v-flex xs12 offset-md1 md5 class="p-0-25">
              <v-flex class="ex-flat-field">
                <label class="ex-flat-label">{{$t('products.need_name')}}</label>
                <v-text-field
                  flat
                  id="product-name"
                  v-model="needData.name"
                  :rules="titleRules"
                />
              </v-flex>
              <v-flex xs12 class="group-name-input">
                <label class="ex-flat-label">{{$t('phone_number')}}</label>
                <v-text-field
                  class="ex-input-group"
                  v-model="needData.phoneNumber"
                  placeholder="+374XXXXXXXX"
                  :rules="phoneNumberRules"
                >
                </v-text-field>
              </v-flex>
              <v-flex  class="ex-flat-field location-sect">
                <label class="ex-flat-label">{{$t('products.location')}}</label>
                <v-combobox
                  v-model="needData.address"
                  @keydown="keydownSearchAddress"
                  @keyup="keyupSearchAddress"
                  @input="selectSuggestedAddress"
                  class="search-individual-input"
                  :items="needData.addressSuggestions"
                  item-text="label"
                  item-value="locationId"
                  :loading="needData.addressSuggestionLoading"
                  :placeholder="$t('products.select_location')"
                  clearable
                  prepend-inner-icon="icon-location"
                  append-icon=""
                  attach=".location-sect"
                >
                </v-combobox>
              </v-flex>
              <v-flex class="category-select">
                <label class="ex-flat-label">{{$t('products.categories')}}</label>
                <v-select
                  class="ex-flat-field"
                  :items="categories"
                  name="CategoryTranslations[0].name"
                  v-model="needData.category"
                  :placeholder="$t('products.select_category')"
                  :rules="categoryRules"
                  item-disabled="hasSubCategory"
                  item-text="CategoryTranslations[0].name"
                  item-value="id"
                  append-icon="icon-angle-down-18"
                  attach=".category-select"
                >
                  <template slot="item" slot-scope="data">
                    <template v-if="data.item.header === ''">
                      <v-list-tile-content v-text="data.item.CategoryTranslations[0].name"/>
                    </template>
                    <template v-else>
                      <v-list-tile-avatar>
                      </v-list-tile-avatar>
                      <v-list-tile-title v-html="data.item.CategoryTranslations[0].name"/>
                    </template>
                  </template>
                </v-select>
              </v-flex>

            </v-flex>
            <v-flex xs12 md5 class="p-0-25">
              <v-flex class="relative mb-25">
                <label class="ex-flat-label">{{$t('products.images')}}</label>
                <div v-if="needData.imageUrl" class="d-flex justify-space-between align-center">
                  <div class="productImg" v-if="needData.imageUrl">
                    <img :src="needData.imageUrl" height="150"
                         :alt="$t('products.image')"/>
                  </div>
                  <div class="productImg" v-else>
                    <img src="../../assets/images/NoImage.png" :alt="$t('products.image')">
                  </div>
                  <vue-dropzone class="ex-abs-dropzone"
                                v-if="needData.imageUrl"
                                v-bind:class="{ clickable: isClickable  }"
                                ref="productImagesDropzone"
                                id="dropzoneAbs"
                                :options="dropzoneOptions"
                                :useCustomSlot=true
                                @vdropzone-file-added="vueFileAdded"
                                @vdropzone-success="productFileSuccess"
                                @vdropzone-removed-file="productRemovedFile"
                                @vdropzone-error="productFileError"
                  >
                    <div class="dz-message" data-dz-message>
                      <v-icon class="f-s-20">icon-plus-big</v-icon>
                    </div>
                  </vue-dropzone>
                </div>
                <div class="subImages">
                  <div v-for="prImage of needData.images" :key="prImage.key" class="preview-product-images">
                    <div @click="selectImageAsGeneral(prImage)" class="replace-image">{{$t('products.select_as_main')}}</div>
                    <v-icon color="pink" @click="removeProductImage(prImage)">icon-cancel</v-icon>
                    <img :src="prImage.dataURL" :alt="$t('products.image')"  @click="selectImageAsGeneral(prImage)" :class="prImage.isActive === true ? 'need-pointer active': 'need-pointer'">
                  </div>
                </div>
                <vue-dropzone :options="dropzoneOptions"
                              :useCustomSlot=true
                              @vdropzone-error="productFileError"
                              @vdropzone-file-added="vueFileAdded"
                              @vdropzone-removed-file="productRemovedFile"
                              @vdropzone-success="productFileSuccess"
                              class="ex-rel-dropzone"
                              id="dropzoneRel"
                              ref="productImagesDropzone"
                              v-bind:class="{ clickable: isClickable  }"
                              v-if="!needData.imageUrl"
                >
                  <div class="dropzone-custom-content relative" v-if="!isClickable">
                    <div class="d-flex justify-center mb-25">
                      <img src="../../assets/images/image-icon.svg" alt="" style="width: 58px">
                    </div>
                    <h3 class="dropzone-custom-title">{{$t('products.drag_and_drop_images')}}</h3>
                    <div class="subtitle">...{{$t('products.or_click_select_file')}}</div>
                  </div>
                </vue-dropzone>
              </v-flex>
              <v-flex  class="ex-flat-field mb-20">
                <label class="ex-flat-label">{{$t('products.description')}}</label>
                <v-textarea

                  flat
                  v-model="needData.description"
                  :rules="productDescRules"
                  :placeholder="$t('products.description-for-1000')"
                  :counter="1000"
                  name="needData.description"
                  no-resize
                  height="142px"
                  rows="6"
                  class="description-field"
                >
                </v-textarea>
              </v-flex>
            </v-flex>
            <!--Group-->
            <v-flex xs12 class="text-xs-right save-cancel-btn-sect">
              <v-btn
                class="g-btn-default g-btn-165 m-0-5 cancel-btn"
                @click="clear"
              >{{$t('products.cancel')}}</v-btn>
              <v-btn
                class="g-btn-main-light g-btn-165 m-0-5 ex-add-btn"
                @click="saveProduct"
                :disabled="loading"
              >
                {{$t('products.save')}}
                <v-progress-circular
                  v-if="loading"
                  size="20"
                  indeterminate
                  color="primary"
                />
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <v-dialog
          v-model="productImgSrc"
          max-width="500px"
          v-if="productImgSrc"
          persistent
        >
          <v-card>
            <v-card-text>
              <vue-cropper
                ref="cropperProductImage"
                :src="productImgSrc"
                :alt="$t('products.image')"
                dragMode="move"
                :aspectRatio="3 / 2"
                :autoCropArea="0"
                :movable="false"
                :rotatable="false"
                :scalable="false"
                :zoomable="false"
              >
              </vue-cropper>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="g-btn-default g-btn-135 m-0-5" flat @click="cancelCropProductImage">{{$t('products.cancel')}}</v-btn>
              <v-btn class="g-btn-main-light g-btn-135 m-0-5" @click="cropProductImage">{{$t('products.crop_image')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode'
import {mapState} from 'vuex'
import {last, validateTitle} from '../../helpers/main'
import vue2Dropzone from 'vue2-dropzone'
import VueCropper from 'vue-cropperjs'

function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
  return []
}

export default {
  name: 'AddNeeds',
  props: ['currentProduct'],
  components: {
    vueDropzone: vue2Dropzone,
    VueCropper: VueCropper
  },
  data: () => ({
    data: '',
    isClickable: false,
    productImgSrc: null,
    productUploadedFile: {},
    productUploadTimer: {},
    show: true,
    valid: true,
    loading: false,
    userData: {},
    fileMaxSizeRules: [],
    needData: {
      category: null,
      name: '',
      description: '',
      imageName: '',
      image: '',
      imageUrl: '',
      imageFile: '',
      images: [],
      addressSuggestionLoading: false,
      address: '',
      addressData: {},
      addressSuggestions: [],
      phoneNumber: '',
      status: false
    },
    defaultItem: {
      category: null,
      title: '',
      description: '',
      imageName: '',
      image: '',
      imageUrl: '',
      imageFile: '',
      status: false,
      images: [],
      addressSuggestionLoading: false,
      address: '',
      addressData: {},
      addressSuggestions: []
    },
    categories: [],
    apiUrl: process.env.ROOT_API
  }),
  computed: {
    roles: () => decodeJwtToken(),
    ...mapState({
      stateUserData: state => state.auth.userData,
      loggedUser: state => state.auth.userData
    }),
    formTitle () {
      return this.show ? this.$t('products.add_product') : this.$t('products.back_to_product_list')
    },
    titleRules () {
      return [
        v => (!!v && v.trim() !== '') || this.$t('products.need_name_required'),
        v => validateTitle(v) || this.$t('products.need_not_valid')
      ]
    },
    phoneNumberRules () {
      return [
        v => !!v || this.$t('pnone_required'),
        v => (!v || /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('phone_not_valid')
      ]
    },
    nameRules () {
      return [v => (!!v && v.trim() !== '') || this.$t('group.group_name_required')
      ]
    },
    noteRules () {
      return [v => (!!v && v.trim() !== '') || this.$t('products.note')
      ]
    },
    categoryRules () {
      return [
        v => !!v || this.$t('products.product_category_required')
      ]
    },
    productDescRules () {
      return [
        v => v.length <= 1000 || this.$t('products.product_desc_valid')
      ]
    },
    dropzoneOptions () {
      return {
        url: process.env.ROOT_API + '/api/postDropzoneImage',
        thumbnailWidth: 130,
        maxFilesize: 8,
        maxFiles: 1,
        timeout: 60000,
        addRemoveLinks: true,
        resizeWidth: 1200,
        acceptedFiles: 'image/*',
        dictRemoveFile: 'X'
      }
    }
  },
  created () {
    if (this.currentProduct) {
      this.editItem(this.currentProduct)
    }
    this.getAllCategories()
  },
  watch: {
    dialog (val) {
      val || this.closeModal()
    }
  },
  mounted () {
    this.getLocation()
  },
  methods: {
    editItem (item) {
      this.needData.name = item.ProductTranslations[0].name
      this.needData.description = item.ProductTranslations[0].description
      this.needData.phoneNumber = item.phoneNumber
      this.needData.imageUrl = item.image ? this.apiUrl + item.image : null
      this.needData.category = item.Category && item.Category.id
      this.needData.id = item.id
      if (item.ProductAddresses[0]) {
        this.needData.addressData = item.ProductAddresses[0].Address
        this.needData.address = item.ProductAddresses[0].Address.label
        this.needData.addressSuggestions = [item.ProductAddresses[0].Address]
      }
      if (item.options && item.options.images && item.options.images.length > 0) {
        item.options.images.forEach(img => {
          img['dataURL'] = this.apiUrl + img['md']
          img['key'] = img['original']
          img['isActive'] = item.image !== null && item.image === img['sm']
        })
        this.needData.images = item.options.images
      }
    },
    getAllCategories () {
      this.$store.dispatch('profile/getAllCategories').then((res) => {
        this.categories = res.categories ? res.categories : []
        let catArr = []
        let subCatArr = []
        this.categories.forEach((cat) => {
          if (cat.needCategory === true) {
            if (!cat.parentId) {
              cat.header = ''
              cat.hasSubCategory = false
              catArr.push(cat)
            } else {
              subCatArr.push(cat)
            }
          }
        })

        let _categories = []
        catArr.forEach((cart) => {
          _categories.push(cart)
          subCatArr.forEach((subCart) => {
            if (cart.id === subCart.parentId) {
              if (last(_categories).hasSubCategory === false) {
                last(_categories).hasSubCategory = true
              }
              _categories.push(subCart)
            }
          })
        })
        this.categories = _categories
      }).catch(console.error)
    },
    changeActive (tab) {
      this.active = tab
    },
    saveProduct () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let _uploadImages = []
        let _existImages = []
        let mainImage = {}
        if (this.needData.images.length > 0) {
          this.needData.images.forEach((img) => {
            if (img.croppedImage) {
              _uploadImages.push(img.croppedImage)
            } else {
              if (!img.isActive) {
                const _img = {...img}
                delete _img.dataURL
                delete _img.isActive
                delete _img.key
                _existImages.push(_img)
              } else {
                mainImage = {...img}
              }
            }
          })
          if (mainImage) {
            delete mainImage.dataURL
            delete mainImage.isActive
            delete mainImage.key
            _existImages.push(mainImage) // the last item is general image
          }
        } else {
          this.$toastr('error', this.$t('profile.image_not_valid'), this.$t('error'))
          this.loading = false
          return false
        }
        const data = {
          id: this.needData.id,
          description: this.needData.description.trim(),
          image: this.needData.image,
          imageFile: this.needData.imageFile,
          imageUrl: this.needData.imageUrl,
          category: this.needData.category,
          status: this.needData.status,
          title: this.needData.name.trim(),
          uploadImages: _uploadImages,
          images: _existImages,
          addressData: this.needData.address ? this.needData.addressData : {},
          phoneNumber: this.needData.phoneNumber
        }
        this.$store.dispatch('profile/saveProduct', data).then((res) => {
          if (res) {
            this.loading = false
            this.$toastr(res.type, res.message, this.$root.$t(res.type))
            this.clear()
            this.$emit('edit')
          }
        }).catch(console.error)
      } else {
        this.$toastr('error', this.$t('fill_required_fields'), this.$t('error'))
        return false
      }
    },
    getLocation () {
      let ipLocationCity = JSON.parse(localStorage.getItem('ipLocation')).city
      this.$store.dispatch('products/getAddressSuggestions', {address: ipLocationCity})
        .then((res) => {
          this.data = res.data.options.suggestions[0].label
          this.needData.address = this.data
          if (this.needData.address) {
            this.needData.addressData = res.data.options.suggestions[0]
          }
          this.needData.addressSuggestions = res.data.options && res.data.options && res.data.options.suggestions
          this.needData.addressSuggestionLoading = false
        })
        .catch((er) => {
          console.log(er.response)
        })
    },
    clear () {
      if (this.currentProduct) {
        this.$emit('edit')
      }
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.defaultItem.images = []
      this.needData = Object.assign({}, this.defaultItem)
      this.openSelected = false
      this.getLocation()
    },
    productFileSuccess (file, response) {
      clearTimeout(this.productUploadTimer)
      this.productUploadedFile = file
      const reader = new FileReader()
      reader.onload = (event) => {
        // event.target.result contains base64 encoded image
        setTimeout(() => {
          this.productImgSrc = event.target.result
        }, 1000)
      }
      reader.readAsDataURL(file)
    },
    vueFileAdded (file) {
      this.isClickable = true
      this.productUploadTimer = setTimeout(() => {
        this.productFileError(file, this.$t('products.image_upload_max_time'))
      }, 60000)
    },
    productRemovedFile (file, error, xhr) {
      clearTimeout(this.productUploadTimer)
      this.destroyCropProductImage()
    },
    productFileError (file, error, xhr) {
      if (file.status === 'canceled') {
        return
      }
      if (file.status === 'error') {
        error = this.$t('products.image_upload_max_size')
      }
      this.destroyCropProductImage()
      this.$refs.productImagesDropzone.removeFile(file)
      this.$toastr('error', error, this.$t('error'))
      this.isClickable = false
    },
    cropProductImage () {
      this.isClickable = false
      // get image data for post processing, e.g. upload or setting image src
      const croppedCanvas = this.$refs.cropperProductImage.getCroppedCanvas({
        fillColor: '#edefef',
        width: 1200,
        height: 800
      })
      if (croppedCanvas) {
        const dataURL = croppedCanvas.toDataURL('image/jpeg')
        this.needData.images.forEach((img) => {
          img['isActive'] = false
        })
        const _productUploadedFile = this.productUploadedFile
        croppedCanvas.toBlob((blob) => {
          this.needData.imageUrl = dataURL
          this.needData.images.push({dataURL: dataURL, key: _productUploadedFile.upload.uuid, filename: _productUploadedFile.upload.filename, croppedImage: blob, isActive: true})
        }, 'image/jpeg', 0.9)
        this.$refs.productImagesDropzone && this.$refs.productImagesDropzone.removeFile(this.productUploadedFile)
        this.productUploadedFile = {}
      }
    },
    cancelCropProductImage () {
      this.isClickable = false
      this.$refs.productImagesDropzone && this.$refs.productImagesDropzone.removeFile(this.productUploadedFile)
      this.productUploadedFile = {}
    },
    destroyCropProductImage () {
      this.$refs.cropperProductImage && this.$refs.cropperProductImage.destroy()
      this.productImgSrc = null
    },
    removeProductImage (image) {
      const imageIndex = this.needData.images.indexOf(image)
      if (imageIndex > -1) {
        this.needData.images.splice(imageIndex, 1)
        if (image['isActive']) { // need to make active other image
          if (this.needData.images[0]) {
            this.needData.images[0].isActive = true
            this.needData.image = this.needData.images[0]['original']
            this.needData.imageUrl = this.needData.images[0]['dataURL']
          } else {
            this.needData.image = ''
          }
        }
        if (this.needData.images.length === 0) {
          this.needData.imageUrl = ''
        }
      }
    },
    selectImageAsGeneral (image) {
      this.needData.images.forEach(img => {
        img.isActive = false
      })
      image.isActive = true
      this.needData.imageUrl = image['dataURL']
      if (image['croppedImage'] === undefined) {
        this.needData.image = image['original']
      }
    },
    keyupSearchAddress (e) {
      this.needData.addressSuggestionLoading = true
      clearTimeout(this.typingTimerSearchAddress)
      this.typingTimerSearchAddress = setTimeout(() => {
        this.$store.dispatch('products/getAddressSuggestions', {address: e.target.value})
          .then((res) => {
            this.needData.addressSuggestions = res.data.options && res.data.options && res.data.options.suggestions
            this.needData.addressSuggestionLoading = false
          })
          .catch((er) => {
            console.log(er.response)
          })
      }, 500)
    },
    keydownSearchAddress () {
      clearTimeout(this.typingTimerSearchAddress)
    },
    selectSuggestedAddress () {
      if (this.needData.address && this.needData.addressSuggestions && this.needData.addressSuggestions.length) {
        const selectedItem = this.needData.addressSuggestions.filter(item => item.locationId === this.needData.address.locationId)
        this.needData.addressData = selectedItem && selectedItem[0]
        // todo need to save this data into new tables of
      }
    },
    openSelectedAria () {
      this.openSelected = true
    },
    closeSelectedAria () {
      this.openSelected = false
    }
  }
}
</script>
<!--@click="deleteModal(friend.Friend.id)"-->
<style lang="scss" scoped>
@import "../../assets/sass/desktop/addProduct";
.ex-rel-dropzone{
  & /deep/ .dz-preview.dz-success .dz-success-mark{
    animation: passing-through 1s cubic-bezier(0.77,0,0.175,1) !important;
  }
}
.ex-rel-dropzone{
  & /deep/ .dz-preview.dz-error .dz-error-mark{
    animation: slide-in 1s cubic-bezier(0.77,0,0.175,1) !important;
  }
}
    @import "../../assets/sass/desktop/myFriends";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/AddNeeds.vue